import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { OpenIdConfiguration } from 'angular-auth-oidc-client';

import { ConfigurationService, InfraPreset, Stage } from '@mobi/rwc-utils-common-ng-jslib';

import { getIdpHintParam } from './internal/cip-auth.config';

/**
 * With this config, when the loginIdp is Nevis it will automatically add idp=raiffeisen (or given idp in the url-param) to the custom param auth (aka "idp-hint")
 */
export const B2bRaiffeisenIdp = (): OpenIdConfiguration => {
    const configurationService = inject(ConfigurationService);
    const stage = configurationService.getSync('stage') as Stage;
    const infraPreset = configurationService.getSync('infraPreset') as InfraPreset;
    const location = inject(DOCUMENT).location;
    const idpHint = getIdpHintParam(stage, infraPreset, location);
    const customParamsAuthRequest = idpHint as Record<string, string>;
    if (idpHint?.kc_idp_hint.startsWith('wesb2b')) {
        const urlSearchParams = new URLSearchParams(location.search);
        const idp = urlSearchParams.get('idp') as IdpHint['idp'] | null;
        customParamsAuthRequest['idp'] = idp ?? 'raiffeisen';
    }
    return { customParamsAuthRequest };
};

type IdpHint = Record<'idp', 'raiffeisen'>;
